export class AdapterDayjs {}
export default AdapterDayjs;
